import React, { useEffect, useLayoutEffect } from "react";

// Style
import "./Libraries.scss";

// Link
import { useNavigate } from "react-router-dom";

// Redux connect
import { useAppSelector } from "lib/hooks/useDispatch";

// components
import { Table } from "./components/Table";
import Loader from "components/UiKit/Loader";
import ErrorBoundary from "components/ErrorBoundary";

// Lib
import Cookies from "js-cookie";
import { urlParams } from "lib/search";
import { shallowEqual } from "react-redux";
import { amplitudeInstance, events } from "constans/cookie";

export const Libraries: React.FC = () => {
  const navigate = useNavigate();

  const params = urlParams(null).get("anchor") as string || "";

  const libraries = useAppSelector((store) => store.libraries, shallowEqual);
  const { loading, diseases, bioActive, drugRepurposing, signalingPathways } = libraries;

  useLayoutEffect(() => {
    const anchor1 = document.querySelector("#drug");
    const anchor2 = document.querySelector("#signaling");
    const anchor3 = document.querySelector("#screening");
    const anchor4 = document.querySelector("#diseases");

    if (anchor1 && params === "drug") {
      anchor1.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    if (anchor2 && params === "signaling") {
      anchor2.scrollIntoView({ block: "start", behavior: "smooth" });
    }

    if (anchor3 && params === "screening") {
      anchor3.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    if (anchor4 && params === "diseases") {
      anchor4.scrollIntoView({ block: "end", behavior: "smooth" });
    }
  }, [navigate, params]);

  useEffect(() => {
    const isCookie = Cookies.get("cookieName");

    if (isCookie) {
      amplitudeInstance.logEvent(events.compound_libraries);
    }
  }, []);

  const compoundsCount = libraries?.compoundsCount;

  const getLoader = () => {
    return <div className="screen-libraries__no-data">
      <div className="wrapper">
        <Loader
          color="dark"
          type="circle"
        />
      </div>
    </div>;
  };

  const getMessageWrong = () => {
    return <div className="screen-libraries__no-data">
      <p className="wrapper">
        Something went wrong. We're working on it and we'll get it fixed as soon as we can.
      </p>
    </div>;
  };

  const getLists = () => {
    return (
      <>
        {!!signalingPathways?.length && <Table
          id="signaling"
          data={signalingPathways || []}
          count={compoundsCount?.compoundsType3 || 0}
          headerTitle="Signaling Pathways<br/> and Protein Classes Related Libraries"
        />}
        {!!bioActive?.length && <>
          <div className="screen-libraries__divider" />
          <Table
            id="screening"
            data={bioActive || []}
            count={compoundsCount?.compoundsType1 || 0}
            headerTitle="Bioactive Screening Compound Libraries"
          /></>}
        {!!drugRepurposing?.length && <>
          <div className="screen-libraries__divider" />
          <Table
            id="drug"
            data={drugRepurposing || []}
            count={compoundsCount?.compoundsType2 || 0}
            headerTitle="Drug Repurposing and Related Libraries"
          /></>}
        {!!diseases?.length && <>
          <div className="screen-libraries__divider" />
          <Table
            id="diseases"
            data={diseases || []}
            count={compoundsCount?.compoundsType4 || 0}
            headerTitle="Disease Related Compound Libraries"
          />
        </>}
      </>
    );
  };

  return (
    <ErrorBoundary>
      <div className="screen-libraries">
        <div className="wrapper relative">
          {loading
            ? getLoader()
            : !libraries?.data.length
              ? getMessageWrong()
              : getLists()}
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default Libraries;